import { render, staticRenderFns } from "./property-carousel.vue?vue&type=template&id=10c3838c&scoped=true"
import script from "./property-carousel.vue?vue&type=script&lang=js"
export * from "./property-carousel.vue?vue&type=script&lang=js"
import style0 from "./property-carousel.vue?vue&type=style&index=0&id=10c3838c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c3838c",
  null
  
)

export default component.exports